"use client";

import { Check } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useState } from "react";
export default function ExploreMore() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section ref={ref} className="relative min-h-screen flex items-center justify-center overflow-hidden bg-background py-24 px-4">
      {}
      <div className="absolute inset-0 bg-cover bg-center opacity-20 blur-sm" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1458826/img/coffee_beans_blurred_background.png)",
      transform: `translateY(${scrollY * 0.1}px)`
    }} />

      {}
      <div className={`relative z-10 max-w-2xl w-full bg-primary-dark/30 backdrop-blur-md rounded-lg shadow-strong border border-primary/20 p-8 md:p-12 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {}
        <h1 className={`font-display text-4xl md:text-5xl font-bold text-foreground text-center mb-4 transition-all duration-1000 delay-200 ${isVisible ? "opacity-100" : "opacity-0"}`}>
          Discover Premium Coffee
        </h1>

        <p className={`text-muted-foreground text-center text-lg mb-8 transition-all duration-1000 delay-300 ${isVisible ? "opacity-100" : "opacity-0"}`}>
          Subscribe to our newsletter and explore Canada's finest specialty coffee roasters
        </p>

        {}
        <FormProvider className={`transition-all duration-700 delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} formId="newsletter-subscription-explore" sectionName="explore-more" defaultValues={{
        email: ""
      }} validationRules={{
        email: {
          required: true,
          pattern: "email"
        }
      }} submitText="Subscribe Now" successMessage="Thank you for subscribing! Check your inbox for exclusive coffee insights.">
          <NewsletterForm />
        </FormProvider>

        {}
        <div className={`mt-6 text-center transition-all duration-1000 delay-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
          <Button variant="outline" className="bg-transparent border-primary text-primary hover:bg-primary hover:text-foreground-primary shadow-medium hover:shadow-strong animate-pulse hover:animate-none transition-all duration-300">
            Browse Top Roasters
          </Button>
        </div>
      </div>
    </section>;
}
function NewsletterForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  const [isFocused, setIsFocused] = useState(false);
  if (isSubmitted && !submitError) {
    return <div className="p-6 bg-accent-light border border-accent rounded-lg text-center space-y-4 animate-fade-in-up">
        <div className="flex items-center justify-center">
          <div className="bg-accent text-foreground-accent rounded-full p-3 animate-bounce">
            <Check className="size-6" />
          </div>
        </div>
        <p className="text-foreground font-semibold">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="mt-4">
          Subscribe Another Email
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit}>
      <FormField control={control} name="email" rules={{
      required: "Email is required",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Please enter a valid email address"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-foreground sr-only">Email Address</FormLabel>
            <FormControl>
              <div className="relative">
                <Input type="email" placeholder="Enter your email address" className={`bg-background/80 border-2 text-foreground placeholder:text-muted-foreground shadow-soft rounded-md px-4 py-3 text-base transition-all duration-300 ${isFocused ? "border-primary shadow-[0_0_20px_rgba(var(--color-primary),0.4)] ring-4 ring-primary/20" : "border-border hover:border-primary/50"}`} onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)} {...field} />
              </div>
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 bg-red-50 border border-red-200 rounded-lg mt-4 animate-fade-in-up">
          <p className="text-red-800 text-sm">{submitError}</p>
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full mt-6 bg-primary text-foreground-primary hover:bg-primary-hover shadow-medium hover:shadow-strong hover:-translate-y-1 active:translate-y-0 transition-all duration-300 py-6 text-lg font-semibold rounded-md">
        {isSubmitting ? <>
            <span className="animate-spin mr-2">⏳</span>
            Subscribing...
          </> : "Subscribe Now"}
      </Button>
    </Form>;
}